import { render, staticRenderFns } from "./DirectionScrolling.vue?vue&type=template&id=50cd873a&scoped=true&"
import script from "./DirectionScrolling.vue?vue&type=script&lang=js&"
export * from "./DirectionScrolling.vue?vue&type=script&lang=js&"
import style0 from "./DirectionScrolling.vue?vue&type=style&index=0&id=50cd873a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cd873a",
  null
  
)

export default component.exports